export const environment = {
  production: true,
  /** Publieke API op site root → /api/customers/... */
  serviceUrl: 'https://api.wasserijengelbertink.nl'
};
